import { LifeSphere } from '../types';

export const donskojSpheres2: LifeSphere[] = [
  {
    id: 'ds4',
    productId: '10',
    name: 'Финансы и материальное благополучие',
    description: 'Ограничивающие убеждения о деньгах, финансовый потолок, долги',
    themes: [{
      id: 'cat_ds4',
      sphereId: 'ds4',
      name: 'Финансы и материальное благополучие',
      description: '',
      subthemes: [
        {
          id: 'dt4_01',
          themeId: 'cat_ds4',
          name: 'Ограничивающие убеждения о деньгах',
          description: 'Глубинные установки, блокирующие финансовый поток и не позволяющие зарабатывать больше',
          units: [
          ],
        },
        {
          id: 'dt4_02',
          themeId: 'cat_ds4',
          name: 'Финансовый потолок',
          description: 'Невидимый барьер дохода, выше которого человек не может подняться',
          units: [
          ],
        },
        {
          id: 'dt4_03',
          themeId: 'cat_ds4',
          name: 'Долги и кредиты',
          description: 'Кредитная ловушка, эмоциональная тяжесть долгов, неспособность выбраться из долговой ямы',
          units: [
          ],
        },
        {
          id: 'dt4_04',
          themeId: 'cat_ds4',
          name: 'Страх бедности',
          description: 'Глубинный страх остаться без средств к существованию',
          units: [
          ],
        },
        {
          id: 'dt4_05',
          themeId: 'cat_ds4',
          name: 'Нестабильный доход',
          description: 'Постоянные колебания заработка, невозможность планировать бюджет',
          units: [
          ],
        },
        {
          id: 'dt4_06',
          themeId: 'cat_ds4',
          name: 'Не могу накопить',
          description: 'Неспособность создать финансовый запас, всё уходит на текущие расходы',
          units: [
          ],
        },
        {
          id: 'dt4_07',
          themeId: 'cat_ds4',
          name: 'Деньги быстро уходят',
          description: 'Ощущение что деньги утекают как песок сквозь пальцы',
          units: [
          ],
        },
        {
          id: 'dt4_08',
          themeId: 'cat_ds4',
          name: 'Зависть к чужому успеху',
          description: 'Болезненное сравнение своего финансового положения с чужим',
          units: [
          ],
        },
        {
          id: 'dt4_09',
          themeId: 'cat_ds4',
          name: 'Страх повышения цен',
          description: 'Тревога из-за роста цен на товары, услуги и жильё',
          units: [
          ],
        },
        {
          id: 'dt4_10',
          themeId: 'cat_ds4',
          name: 'Не умею продавать себя',
          description: 'Неспособность презентовать свои навыки и знания для увеличения дохода',
          units: [
          ],
        },
        {
          id: 'dt4_11',
          themeId: 'cat_ds4',
          name: 'Боязнь больших денег',
          description: 'Подсознательный страх перед крупными суммами и ответственностью, которую они несут',
          units: [
          ],
        },
        {
          id: 'dt4_12',
          themeId: 'cat_ds4',
          name: 'Привычка экономить на себе',
          description: 'Отказ от базовых потребностей и удовольствий ради экономии',
          units: [
          ],
        },
        {
          id: 'dt4_13',
          themeId: 'cat_ds4',
          name: 'Финансовая зависимость от партнёра',
          description: 'Невозможность обеспечить себя самостоятельно, зависимость от дохода супруга',
          units: [
          ],
        },
        {
          id: 'dt4_14',
          themeId: 'cat_ds4',
          name: 'Не могу найти хорошую работу',
          description: 'Трудности с трудоустройством, неудовлетворённость текущей работой',
          units: [
          ],
        },
        {
          id: 'dt4_15',
          themeId: 'cat_ds4',
          name: 'Бизнес не растёт',
          description: 'Стагнация бизнеса, невозможность масштабирования, выгорание предпринимателя',
          units: [
          ],
        },
      ],
    }],
  },
  {
    id: 'ds5',
    productId: '10',
    name: 'Саморазвитие и духовный рост',
    description: 'Поиск смысла жизни, духовные практики, личностный рост, самопознание',
    themes: [{
      id: 'cat_ds5',
      sphereId: 'ds5',
      name: 'Саморазвитие и духовный рост',
      description: '',
      subthemes: [
        {
          id: 'dt5_01',
          themeId: 'cat_ds5',
          name: 'Поиск смысла жизни',
          description: 'Экзистенциальные вопросы, ощущение бессмысленности, поиск предназначения',
          units: [
          ],
        },
        {
          id: 'dt5_02',
          themeId: 'cat_ds5',
          name: 'Кризис среднего возраста',
          description: 'Переоценка жизни в 35-50 лет, разочарование, страх упущенных возможностей',
          units: [
          ],
        },
        {
          id: 'dt5_03',
          themeId: 'cat_ds5',
          name: 'Не знаю чего хочу',
          description: 'Отсутствие чётких желаний и целей, потерянность в выборе пути',
          units: [
          ],
        },
        {
          id: 'dt5_04',
          themeId: 'cat_ds5',
          name: 'Духовный кризис',
          description: 'Потеря веры, разочарование в духовных системах, тёмная ночь души',
          units: [
          ],
        },
        {
          id: 'dt5_05',
          themeId: 'cat_ds5',
          name: 'Хочу изменить жизнь, но не знаю как',
          description: 'Сильное желание перемен при полном непонимании первых шагов',
          units: [
          ],
        },
        {
          id: 'dt5_06',
          themeId: 'cat_ds5',
          name: 'Разочарование в тренингах и практиках',
          description: 'Потеря веры в методы саморазвития после многочисленных неудачных попыток',
          units: [
          ],
        },
        {
          id: 'dt5_07',
          themeId: 'cat_ds5',
          name: 'Потеря интереса ко всему',
          description: 'Ангедония, эмоциональное выгорание, отсутствие радости от жизни',
          units: [
          ],
        },
        {
          id: 'dt5_08',
          themeId: 'cat_ds5',
          name: 'Работа с подсознанием',
          description: 'Перепрограммирование убеждений, работа с установками, выход из автоматических реакций',
          units: [
          ],
        },
        {
          id: 'dt5_09',
          themeId: 'cat_ds5',
          name: 'Медитация и осознанность',
          description: 'Трудности в практике медитации, поиск внутреннего покоя, развитие осознанности',
          units: [
          ],
        },
        {
          id: 'dt5_10',
          themeId: 'cat_ds5',
          name: 'Освобождение от прошлого',
          description: 'Неспособность отпустить прошлые события, обиды, потери и двигаться дальше',
          units: [
          ],
        },
        {
          id: 'dt5_11',
          themeId: 'cat_ds5',
          name: 'Программирование реальности',
          description: 'Осознанное создание своей реальности через мысли, намерения и энергию',
          units: [
          ],
        },
        {
          id: 'dt5_12',
          themeId: 'cat_ds5',
          name: 'Карма и родовые программы',
          description: 'Влияние родовых сценариев, повторение судьбы предков, кармические уроки',
          units: [
          ],
        },
        {
          id: 'dt5_13',
          themeId: 'cat_ds5',
          name: 'Работа с энергетикой тела',
          description: 'Ощущение энергетических блоков, работа с чакрами, восстановление энергии',
          units: [
          ],
        },
        {
          id: 'dt5_14',
          themeId: 'cat_ds5',
          name: 'Позитивное мышление не работает',
          description: 'Разочарование в попсовом позитиве, токсичная позитивность, поиск реальных инструментов',
          units: [
          ],
        },
        {
          id: 'dt5_15',
          themeId: 'cat_ds5',
          name: 'Поиск наставника и учителя',
          description: 'Потребность в проводнике, сложности выбора наставника, разочарование в учителях',
          units: [
          ],
        },
      ],
    }],
  },
];